import styled from 'styled-components';

const Divider = styled.div<{ $color: 'black' | 'white' }>`
	width: 1px;
	height: 100%;
	background-color: ${(props) =>
		props.$color === 'black'
			? 'rgba(0, 0, 0, 0.1)'
			: 'rgba(255, 255, 255, 0.1)'};
`;

export { Divider };
